module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapname2"
  }, [_vm._v("An Introduction to the Series")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he photographic equipment in use during the Great War was cumbersome and bulky and the environment of the trenches was highly lethal. As a result, the ability to take snapshots was extremely limited, making it all but impossible to capture meaningful shots of the fleeting moments of action. Furthermore the output of cameramen was subject to intense censorship; in consequence, action sequences from the front were so rare and sanitised that the popular magazines reporting the events, on both sides of the line, were forced to recruit artists and illustrators to fill the gap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These artists were called upon to produce a highly accurate visual record of the events the camera could not capture; hand to hand fighting, trench raids, aerial dogfights, sea battles, desperate last stands, individual acts of heroism, night actions and cavalry charges. They were there to record events on the battlefield for commercial purposes and their work usually found a home in popular magazines such as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The War Illustrated")]), _vm._v("; the result of their efforts was a huge body of work which spanned the full gamut of styles ranging from the simplest of sketches through to highly finished oil paintings on a grand scale.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In their foremost ranks were skilled technicians such as Richard Caton Woodville Jr. and William Barnes Wollen both of whom can stand comparison with the great artists of any age. Many of these artists including, of course, Richard Caton Woodville Jr. had served in the military. They were amazingly talented and their work is of superb quality. They also had the eye for detail in terms of uniform, equipment and weapons which brings added authenticity to their work.They were also able to conjure up for the viewer an impression of the genuine stresses and strains of combat from the soldier’s point of view.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(4).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("‘The Second Battle of Ypres’ by William Barnes Wollen")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(5).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("‘The Charge of the 9"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Lancers at a German Battery Near Mons’ by Richard Caton Woodville Jr.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The canon of works by these two great artists alone includes such masterpieces as Barnes Wollen’s ‘Landrecies’, 25 August 1914, ‘The Defeat of the Prussian Guard’, Ypres, 1914, ‘The Canadians at Ypres’ and ‘The London Territorials at Pozières’. Richard Caton Woodville Jr.’s works include ‘The Piper of Loos’, ‘The Battle of the Somme’, ‘The 2"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("nd")]), _vm._v(" Batt. Manchester Regiment taking Six Guns at dawn near St. Quentin’, ‘The Entry of the 5"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Lancers into Mons’,‘The Charge of the 9"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Lancers at Moncel’, 7 September 1914, and the magnificent 'Halloween, 1914: Stand of the London Scottish on Messines Ridge'.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is a strange state of affairs but even with such luminaries to call upon, the work of the contemporary combat illustrators of the Great War, for illustrative purposes, is today almost entirely overlooked in favour of the work of the photographers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The reason for this sad state of affairs lies in the fact that, besides the excellent work by the likes of the brilliant Barnes Wollen, there was an army of more pedestrian artists at work and many of the lesser gifted were engaged in turning out crude images to feed the populist pages of the consumer publishing machine. Primarily as a result of their efforts the whole corpus of wartime illustration has become tainted with the tag of propaganda, and in consequence the remarkable work of even the greatest of Great War graphic artists is now extremely unfashionable. It is considered to be vulgar and is routinely dismissed as melodramatic and jingoistic and all too often mischaracterised simply as crude populist propaganda. Publishers now turn their backs on these works which are no longer considered worthy to illustrate modern history books.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another group at work in the trenches were the humorists and chief among those was the peerless Bruce Bairnsfather. Bairnsfather had seen action during 1914 and 1915 as a machine gun officer serving with the Warwickshire Regiment. His finely observed work grew out of his experience in the Ypres salient and began to appear in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Bystander ")]), _vm._v("during 1915. By 1917 Bairnsfather was already one of the most widely recognised artist/illustrators of his day, but in our day his work is viewed as holding little relevance for serious students of the Great War. This is a great shame as his finely crafted observations have a great deal to tell us concerning the appalling conditions endured with such stoicism by the British troops on the Ypres salient serving under the shadow of the German trenches.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(6).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("‘Things That Matter’. Col. Fitz-Shrapnel receives the following message from ‘G.H.Q.’ “Please let us know, as soon as possible, the number of tins of raspberry jam issued to you last Friday”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fortunately there remains a wider appreciation for the work of the official war artists. We can be thankful that, in addition to the work of the still photographers and the illustrators, there was a general appreciation by the governments of all sides that, as well as the simple act of recording the events, there was also the need to record that which ‘the camera cannot interpret.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The British government in particular came to the gradual realisation that “a war so epic in its scope by land, sea and air, and so detailed and complex in its mechanism,” required interpretation, not just by technicians, but also by artists and this led to the appointment of the first official war artists.The War Artists were able to present a vivid picture of the world as it really was, in full colour, just like our own world and today, through their work we are privileged to have access to a remarkable record of the Great War which brings back the dimension of colour to an otherwise grey world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The British official war artists were a select group of artists who were employed on contract, or commissioned to produce specific works during the Great War. However it wasn’t until May 1916, some two years after the outbreak of the war, that the British Government appointed Muirhead Bone as Britain's first official war artist.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(7).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("‘The Kensingtons at Laventie’ by Eric Kennington")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Official war artists were appointed by governments to record events as a matter of record but others were commissioned for propaganda purposes. War artists depicted diverse aspects of the Great War through his or her art; this might be a pictorial record or a comment on some other aspect of war or it might seek to cast a light on how war blights lives. Muirhead Bone worked exclusively in pencil and ink with publication in Government magazines in mind. As a result, through his work, we still see the world in the same monochrome shades as the official photographs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, after Bone returned to England, he was replaced by his brother-in-law Francis Dodd. It is disappointing that Dodd specialised mainly in portraits many of which could just as easily have been created at home. They throw little light on the nature of the Great War. In addition Dodd was very sparing in his use of colour, but the muted red shades which occasionally creep into his work indicated that the door to the world of colour was at last sliding open. Mercifully, in 1917, arrangements were made to send other artists who possessed greater artistic ambition to France. Included in their ranks was Eric Kennington who is best known for his painting of ‘The Kensingtons at Laventie’ which depicted his former unit at rest during a lull in the hard-fought battles of 1915. Although there were no official war artists before 1916, Kennington had already served at the front with the 13"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Battalion of The London Regiment who were known as ‘The Kensingtons’, he saw action from 1914 until he was invalided out in June 1915 after accidentally shooting himself in the toe!")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(8).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("‘Ready to Start’ by William Orpen")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The famous painting was constructed from memory and depicts the artist in 1915 standing behind and to the right of the soldier in the white hat. Kennington recreates the scene as his platoon rested in a village after four sleepless days and nights in the snow covered trenches. The exhausted men are waiting for the order to march on to a warm billet and the picture conveys that sense of almost dreamlike weariness. With Kennington we at last begin to experience the world of the Great War, not as a hum drum monochrome but as a world of emotion and colour. It was also the beginning of a trend which was to lead to a remarkable body of work as artists on both sides worked to capture the essence of the events as they saw them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("William Orpen was another official war painter who was able to open a door to the events of the Great War. In 1917 he travelled to the Western Front and along with the usual official portraits of generals and politicians he produced drawings and paintings of private soldiers, dead soldiers and German prisoners of war. His self portrait ‘Ready To Start' depicts the artist reflected in a mirror while preparing to set off for duty in the Front Line and neatly encapsulates the manner on which war intrudes on the ordinary world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For his war work, Orpen was made a Knight Commander of the Order of the British Empire. He was selected as a member of the Royal Academy in 1919. Orpen gave most of his war time works, some 138 in all, to the British government on the understanding that they should be framed in simple white frames and kept together as a single body of work. They are now in the collection of the Imperial War Museum in London. William Orpen came to loathe the politicians who prolonged the Great War but he also relied upon them for post-war commissions so he chose to embody his subtle criticism in his work.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(9).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("‘Over the Top’ (the 1"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("st")]), _vm._v(" Artist Rifles at Marcoing) by Paul Nash")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Orpen produced some very strong work during the war, but interestingly he was also present at the political wrangling after the war. His large paintings of the Versailles Peace Conference feature a rather insolent focus on the gilt trappings of the room rather than the politicians gathered there.There is an emphasis on distortion. By doing that he made a strong statement concerning the distorted nature of the political wranglings and the insignificance of the politicians compared to framework which was built on the sufferings of those who made the golden prospects of peace possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even more outspoken was the artist who, like Orpen, witnessed the events in France, he was Paul Nash. The young Paul Nash reluctantly enlisted in the Artists' Rifles and was sent to the Western Front in February 1917 by which time he was a second lieutenant in the Hampshire Regiment. A few days before the Third Ypres offensive he fell into a trench, broke a rib and was invalided home. While recuperating in London, Nash worked from his front-line sketches to produce a series of works which accentuated the harshness of the war. His work such as the celebrated paintings ‘Over the Top’ (the 1"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("st")]), _vm._v(" Artist Rifles at Marcoing), the 'Menin Road' and the 'Ypres Salient at Night' embodies the influence of the Vorticist movement, in fact it became the vanguard of that movement and was well received when it was exhibited later that year at the Goupil Gallery. His work was also featured in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blast ")]), _vm._v("magazine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The staff of the Propaganda bureau were naturally wary of the anti-war sympathies which were embodied in the work of Paul Nash and they subjected the artist to particularly strict control. Nash objected to such censorship and he recorded his views in a letter home to his wife dated 16 November 1916 in which he wrote, ‘I am no longer an artist interested and curious, I am a messenger who will bring back word from the men who are fighting to those who want the war to go on for ever. Feeble, inarticulate, will be my message, but it will have a bitter truth, and may it burn their lousy souls.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The story of the men who fought in the Great War was tough and brutal, but even worse was the experience of those who were maimed by shellfire or poisoned by gas. The artist who was best positioned to highlight their plight was Christopher R. W. Nevinson.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the outbreak of the war Nevinson joined the Friends’ Ambulance Unit, which his father had helped to found, and was deeply disturbed by his work tending wounded French soldiers. For a brief period he served as an ambulance volunteer until, in 1915, ill health forced his return to Britain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nevinson used these experiences as the subject matter for a series of powerful paintings which used Futurist techniques to great effect. His 1916 painting of French Troops Resting is a perfect example of how the modernist style could be harnessed to capture the misery of even day to day life in the war; Nevinson’s painting ‘La Mitrailleuse’ tells us everything we need to know about the industrial nature of the war and Walter Sickert wrote ‘this will probably remain the most authoritative and concentrated utterance on the war in the history of painting.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nevinson volunteered for home service with the Royal Army Medical Corps, before being invalided out; he was eventually appointed as an official war artist, though his later paintings, based on a short visit to the Western Front, lacked the same powerful reception as those earlier works which had helped to make him one of the most famous young artists working in England. The reason for the loss of impact lies in the fact that, by 1917, Nevinson was no longer finding Modernist styles adequate for describing the horrors of modern war and he switched to a realistic style. ‘Paths of Glory’, depicts two fallen British soldiers in a never ending landscape of mud and barbed wire, this particular study is typical of his later war paintings. It is starkly realistic and it’s notable for the complete lack of Futurist or Vorticist effects. Similarly, 'A Taube' reflects the human cost of an air raid.We expect to see a Taube, which was a German aircraft, but by juxtaposing the name of the aircraft with the pathetic, lifeless body of a child, Nevinson achieves a far greater effect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Great War was fought not just on land, but at sea and in the air. Every bit as important as all of these theatres was the home front where superhuman efforts were required to keep the armed forces in weapons, rations and ammunition.These were the sinews of war and John Lavery was the artist who was recruited to paint pictures of the home front. In this industrial war, what happened at home was every bit as important as the events on the fighting fronts. Without arms, ammunition and the whole paraphernalia that an army needs, everything just grinds to a halt. The labour shortage transformed society by bringing women into the war effort and he did a wonderful job of depicting the effects of the war on the home front. However, we should not overlook the contribution of other outstanding artists working in the same field such as Walter Bayes who painted the famous image of families taking shelter in the underground.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(10).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("‘Gassed’ by John Singer Sargeant")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s here on the home front that we see female artists at work and artists such as Anna Airy and Flora Lion did a remarkable job of capturing those images of women at work in what had previously been a man’s world.The fact that women were not just doing the work but also making the art was a double departure from the norm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A war artist essentially creates a visual account of war by showing its impact as men and women are shown waiting, preparing, fighting, working, suffering and celebrating.The works produced by war artists are immensely varied and they form an all too often overlooked record of many aspects of war. They record differing aspects of individual’s experience of war, whether allied or enemy, service or civilian, military or political, social or cultural.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps the most famous painting to emerge from the Great War is ‘Gassed’ by John Singer Sargeant, it depicts the aftermath of a mustard gas attack on the Western Front in August 1918. In the painting, a line of British soldiers who have been exposed to a gas attack are being led along a duckboard walkway at le Bac-du-sud dressing station by a medical orderly. Their eyes are bandaged as a result of exposure to gas and each man holds on to the shoulder of the man in front.There is another line of temporarily blinded soldiers in the background, and the artist spares the viewer none of the horrors of war as one soldier is leaning over vomiting onto the ground. In contrast to the agony of suffering in the foreground we see a glimpse into the world of those unaffected by the gas as a football match continues in the background, the players oblivious to the horrors of the foreground scene.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(12).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("‘For What?’ by Frederick Varley")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Frederick Varley is one of the most justifiably celebrated war artists and his painting entitled ‘For What?’, captures the desolate futility of the Great War. His study of captured German prisoners is also exceptional. He seems to be saying to us ‘well where’s the martial glory in all this?’ All this effort and expenditure to round up a few ragged individuals who look more like beggars trudging through a ravaged landscape on a road to nowhere. Everything in the painting just screams waste, folly and emptiness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The German war artists and illustrators were equally hard at work. Without their efforts we wouldn’t have the German perspective on unique events such as the war from the perspective of the crew of a Zeppelin over London. Despite the prevailing national stereotype of the humourless Teuton, the Germans too had their satirists. They mainly found expression in the long running Bavarian humour magazine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Simpiccissimus")]), _vm._v(".The artist who has risen to the highest prominence is, of course, Otto Dix, his ‘Stormtroopers Advancing Under Gas’, is now one of the most famous images to emerge from the Great War. This work was released as both an etching and an aquatint by Dix in 1924. During this period Dix had begun to specialise in the grim reality of the lingering effects of the war in Weimar Germany. His images of the war wounded and the decaying moral fabric of German society have a haunting quality which still hits home hard even today. Along with George Grosz, Dix is widely considered one of the most important artists of the Neue Sachlichkeit.When the First World War erupted, Dix enthusiastically volunteered for the German Army. He was assigned to a field artillery regiment in Dresden. In the autumn of 1915 he was assigned as a noncommissioned officer of a machine-gun unit on the Western front and took part in the Battle of the Somme. In November 1917, his unit was transferred to the Eastern front until the end of hostilities with Russia, and in February 1918 he was stationed in Flanders. Back on the western front, he fought in the German Spring Offensive. He earned the Iron Cross (second class) and reached the rank of vizefeldwebel. In August of that year he was wounded in the neck, and shortly after he took pilot training lessons. He was discharged from service in December 1918.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(13).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("‘Stormtroopers Advancing Under Gas’ by Otto Dix")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dix was profoundly affected by the sights of the war, and later described a recurring nightmare in which he crawled through destroyed houses. He represented his traumatic experiences in many subsequent works, including a portfolio of fifty etchings called 'Der Krieg’, published in 1924.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the centenary of the Great War approached, I decided the time had come to undertake a full scale reappraisal not just of the Official War Artists but also of the neglected output of the contemporary combat artists and illustrators of the Great War.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was soon apparent that far from being mere romantic fantasies these long neglected images are often highly accurate in every detail.Where the artist was present these works form a primary source of war reportage which is every bit as important as the written word. These works are often a valid and highly authentic secondary record based on eyewitness accounts. The artists at work during the Great War were able to work with the writers who had witnessed the events and often fighting men themselves and they worked to produce a fresh visual account of the action which could not be recorded by any other means. These illustrations are important as they form a valid record of the reality of the fighting as viewed through contemporary eyes.Taken together these works actually form a priceless picture of how the reality of the action at the front was conveyed to contemporary audiences at a time when the events of the war were still unfolding.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Bob Carruthers")]), _vm._v(" "), _c('p', {
    staticClass: "pbrk"
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(14).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("An Irish battalion attacks during the fighting between Landrecies and Cambrai.This spirited rendition shows German soldiers being repelled using bayonets.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(15).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("26 August 1914 – During the Battle of Cambrai a number of the Gordons found themselves cut off entirely from their battalion when an order for retirement was not relayed successfully.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(16).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("12 September 8 October 1914 Night fighting during the Battle of the Aisne. The British losses here, in killed, wounded, and missing, totalled 561 officers and 12,980 men.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(17).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A portrayal of a German trench under attack from the British at night.. Soldiers stand with bayonets poised, facing out of the trench and in to the enemy.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(18).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("As shells burst over head soldiers wait with their bayonets poised during the Battle of Cambrai.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(19).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British infantry push through wire defences.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(20).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Enemy shells burst in a British trench.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(21).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("This image shows an impression of Private Charles Bell from a company of the 1"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("st")]), _vm._v(" West Yorkshire Regiment (The Prince of Wales’s Own) carrying his sergeant to safety. Bell travelled for two hours with his sergeant on his back before reaching the field transport.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(22).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("14 September 1914 – Captain Haggard, Welsh Regiment, lies on the ground mortally wounded, as his men push forward around him near Chivy.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(23).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("The enemy defences that faced a British attack. German soldiers hide their trenches behind clumps of bushes to conceal their troops and weapons.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(24).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("14 September 1914 – Private George Wilson, of the Highland Light Infantry, won the Victoria Cross for single-handed attacking and winning a German machine-gun position near Verneuil.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(25).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("1-4 October 1914 British infantry advance under shellfire at Arras. The advancing allies were supported by over three hundred guns, resulting in a successful attack on the German trenches.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(26).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A surprise attack at night by Britain’s allies.The Gurkhas spring upon the enemy using their traditional weapon called a kukri. Stealth attacks were vital in gaining ground and enemy trenches.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(27).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("31 October 1914 – The 1"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("st")]), _vm._v(" Battalion of the London Scottish charge near Messines. Their resilient attack under heavy fire earned them a special thanks from Sir John French.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(28).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("German troops use wooden planks to traverse the boggy ground and canals in the Yser district.This useful piece of equipment also doubeld as a shield, although it was not very effective.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(29).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("November 1914 – French soldiers advance in a snowstorm through the flooded ditches and bare woods of Southern Belgium, in an image by M. Paul Thiriat.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(30).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Shown here is an impression of fighting at Dixmunde by Breton Marines under Admiral Ronarc'h. 7,000 Breton Marines managed to fend off the attacks of two German army corps for weeks.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(31).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Freezing conditions often resulted in snow storms and blizzards which greatly impared the French forces’ ability to track down the enemy successfully. Vision was often reduced to just half a mile.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(32).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("This illustration shows some of the fiercely contested hand-to-hand fighting that went on in the forest region of the Argonne throughout the winter, where the same trenches changed hands often.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(33).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Veterinary doctors attached to the Blue Cross receiving a wounded war horse for treatment. First-aid having been rendered, the wounded animals were drafted to depots for surgical and medical attention.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(34).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British and German troops pit their marksmen against one another by firing at targets such as empty tins positioned on their trench edges which were sometimes no more than fifteen yards apart.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(35).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("An artist's portrayal of a charge of Turcos over fire-swept open country. Having taken one trench, the Moroccans are advancing under shell and shrapnel fire across the coverless country here.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(36).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A wounded British officer carries a German soldier back to his nation's lines.The German soldier had been shot and fallen behind during an attack on a British trench.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(37).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Indian troops mourn the death of a comrade far from home.The frozen trenches of France were a far cry from the sunshine of India.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(38).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British soldiers making a dash for it across an opening in a long sand-bagged communication trench.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(39).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("How the Northumberland Fusiliers met an attack on their first-line trenches at Ypres.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(40).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("‘The Smile of Victory’ by C.M. Sheldon.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(41).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British soldiers watch the effect of their gun fire from the relative safety of a sandbagged ruin positioned not far from German lines.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(42).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A relief party heads toward the trenches. Here they are shown travelling along ‘Regent Street’ in Ploegsteert Wood, near Ypres.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(43).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("May 1915 – Canadians defend amongst the bodies of their fallen comrades at ‘Stony Mountain’. Portrayed here are Lieutenant Campbell and Private Vincent.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(44).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A private crawls along the floor bringing bombs to his comrades during fighting at 'Stony Mountain', where Canadians played a vital part in the allied campaign.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(45).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("First-aid is administered to wounded soldiers scattered throughout the trenches by the R.A.M.C. after a successful advance.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(46).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British officers take an 'afternoon tea break' during a halt in the fighting in the Ypres salient, and enjoy a rare reprieve from the chaos.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(47).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Shell fire explodes on the battlefield on Neuve Chapelle, as allied troops shelter behind sandbags surrounded by strewn possessions.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(48).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Depicted here is the death of Lieutenant-Colonel Birchall, who was shot by the enemy whilst leading a charge of the 4"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Canadians at Ypres.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(49).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("25 May 1915 – Here Richard Jack portrays a scene witnessed during the Second Battle of Ypres. A soldier orders his men forward in to the fray as smoke fills the air around him.")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("To the left of the scene we see a wounded soldier being supported away from the eye of the attack where German soldiers have reached the British barricades.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(51).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("19-20 May 1915 – An artist’s impression of Lance-Corporal Albert Jacka, 14"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Australian Infantry, fending off an attack from Turkish forces.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(52).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("19 July 1915 – Here is shown an image of a British cavalry charge in the region of the chateau and village of Hooge, an area of intense fighting.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(53).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A Scottish regiment returns from the trenches.They are accompanied by the strains of the bagpipe as they march through Northern France.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(54).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British soldiers in a support trench see a horse ambulance rushing towards them uncontrolled, as shells burst all round the vehicle.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(55).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Weary troops arrive at their billets as the sun rises, having travelled through the night on a forced march to the town.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(56).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("June 1915 – Despite experiencing heavy losses Canadian forces were able to persevere and recapture lost ground in the vicinity of Ypres.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(57).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British troops bring up artillery to support their strained infantry attack near Ypres. Field artillery played a vital role in the British advances here.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(58).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Smoke obscures the moon as fire instead illuminates soldiers observing a blazing farm set alight by German shells on the battlefield in Flanders.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(59).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("This artist's impression shows Rifleman Matthews, 1"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("st")]), _vm._v(" Rifle Brigade attempting to bring in a wounded comrade despite the heavy enemy fire, before escaping in to the adjacent wood.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(60).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("At Le Cateau, Lance-Corporal Holmes, of the 2"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("nd")]), _vm._v(" Yorkshire Light Infantry transports a wounded comrade to safety despite having to leave behind his equipment in order to do so.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(61).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A young Highlander is tragically cut down near Hooge.The soldier was part of a party of bombers led by Lieutenant T. Barrie Erskine, 4"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Argyll and Sutherland Highlanders (attached to the 1"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("st")]), _vm._v(" Gordons).")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(62).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A moving depiction of an event reported at Neuve Chapelle. A mortally wounded officer refuses to leave the battlefield, instead choosing to stay and watch the advance of his regiment.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(63).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A Lance-Corporal attempts a rescue.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(65).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Another rescue attempt by a brave soldier.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(64).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A private firing at the enemy during battle.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(66).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A Lieutenant in combat.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(67).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Two stealthy soldiers recapture a trench from German forces. Emerging from around the corner we see Lieutenant Leach and Sergeant Hogan.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(68).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A dramatic artist’s impression of Sergeant O’Leary capturing a German position. Much of the allied war art featured supposed acts of bravery by their men.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(69).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Whilst defending 'Hill 60' Second-Lieutenant G. H.Woolley became the first Territorial to win a V.C.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(70).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("25 September 1915 – A painting by C.M. Sheldon depicts a British charge at Loos.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(71).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Using a field telephone a British artillery observation officer watches the effect of shell fire and relays the results to his battery commander.This was a vitally important task, that often decided the outcome of an attack.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(72).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Soldiers dive for cover as shells explode around them and smoke fills the trenches.The sandbags lining the men's fortifications are thrown in to the air by the blasts.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(73).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Dead and wounded soldiers litter the battlefield in an artist's interpretation below. The devastation depicted in this scene was sadly commonplace throughout the Great War.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(74).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Many artist’s depictions of battle, such as the image above, showed exaggerated scenes of bravery by their nation’s troops in an effort to reassure and encourage their people. Although there were thousands of incidents of enormous heroism during the war, pictures such as this are often hyperbolic.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(75).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("March 1915 – Indian troops charge a German line at Neuve Chapelle.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(76).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A skirmish in a crater is depicted here by war artist Christopher Clark.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(77).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A brave soldier encourages his men as they engage the enemy using their rifles in France.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(78).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Men in the trenches often reported strange phenomena, such as the mirage depicted below.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(79).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("The Northumberland and Royal Fusiliers charge a German line at St. Eloi, pushing their way through barbed wire and mud to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Although this artist’s depiction paints a heroic picture, the image highlights the issues faced by British soldiers when attacking.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(81).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("French soldiers firing 'taupias', these were small trench guns made of shell-casing.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(82).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Barbed-wires cutters take cover.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(83).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Italians consolidate a captured trench.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(84).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("April 1916 – Troops of the Royal Inniskilling Fusiliers and Royal Dublin Fusiliers leaving their trenches and charging the Germans at the Chalkpit Salient, south of Hulluch.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(85).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("July 1916 – As the ‘big push’ begins, British troops advance over the captured German trenches on a Somme battlefield.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(86).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("In this vivid painting by James Prinsep Beadle men of the Ulster Division are shown advancing into the German trenches during the opening day of the Somme. The troops shown are of the 5"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Battalion Royal Irish Rifles (North Belfast Volunteers) a supporting unit to the 108"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Infantry Brigade.The officer shown leading the unit is Lieutenant Francis Bodenham Thornley.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(88).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("1 July 1916 British first line of attack taking up position in front of their barbed-wire defences.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(89).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("The wounded soldiers are dragged from the battlefield by regimental stretcher-bearers.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(90).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("This image depicts a soldier rescuing his comrade from a shell-hole on the Somme. The battlefield very quickly became mired, which added a new peril to soldiers from all nations.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(91).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("1-13 July 1916 – At Montauban, many German soldiers became trapped in their funk-holes for days as they had been cut off from the communication trenches. This bombardment technique was very effective, but did not strike the blow to the enemy that the British hoped it would.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(92).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("The maze of underground cellars underneath Montauban was cleverly utilised by the occupying German forces as a mixture of store houses and living quarters. Here we see an artist’s rendition of British troops carrying electric torches clearing the cellars of German forces.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(93).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Here W. B. Wollen depicts the struggle endured by the London Territorials at Pozières. Through the smoke fallen soldiers are visible amongst the rubble.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(94).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("This picture depicts British troops attempting to subdue a night counter-attack near Pozières. The German positions are lit up by flares.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(95).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("14 July 1916 An exaggerated image purports to show a British officer at Bazentin-le-Petit throwing a German soldier in to his own defences, as two men fight hand to hand on the floor behind him.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(96).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("19-20 July A portrayal of Australian soldiers at Fromelles. The German army flooded captured trenches here which meant that Anzac troops often found themselves up to their waists in water whilst being fired upon by enemy machine-guns.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(97).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Allied soldiers attempt to stamp out flares during a night attack at Mouquet (known to British soldiers as Moo-Cow Farm).The defending Germans would send up flares to illuminate the advancing infantry, so it was imperative they were kicked out quickly.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(98).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("At Delville Wood the fighting was known to come down to hand to hand combat among the scarred trunks of burnt out trees and craters of mud.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(99).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("3-6 September 1916 – This picture shows Irish troops during an advance at Guillemont. They were able to overcome an enemy machine-gun to capture this trench.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(100).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Behind a line of bursting shells we see British forces moving in to attack the German front-line trenches.These bombardments were key to the eventual allied victory.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(101).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("13-18 November 1916 – German troops are forced in to surrender by intense shelling and infantry pressure during the Battle of the Ancre.The fighting here lasted for days.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(102).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A British officer stands on a parapet and gives the signal for the barrage to lift so that the infantry can advance at Combles.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(103).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("An artist depicts a successful attack upon German soldiers by three Frenchmen, who use bayonets and even their fists attempting to subdue the enemy.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(104).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("15 September 1916 – A depiction of a British success at Martinpuich and Courcelett, here three battalions of the Coldstream Guards charged in line, followed by Grenadiers and Irish Guards.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(105).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Desperate fighting is shown here during the storming of the Schwaben Redoubt, a crest north of Thiepval, that was the highest ground on the Thiepval Spur.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(106).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("This vivid illustration shows British soldiers advancing across the battlefield, heavy packs and rifles slung over their backs as shells rain down in the background.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(107).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("26 September 1916 – Soldiers swarm over the top of a trench at Theipval. After heated combat, allied troops were able to seize the high ridge east of Thiepval in a tactical victory.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(108).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("An illustration depicting a British officer and sergeant of the WestYorkshires embarking on a nocturnal raid in to German trenches after cutting through the enemy’s wire defences under cover of darkness.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(109).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("An artist’s impression of Private A. Hill of the Royal Welsh Fusiliers leading a British attack on a German trench. He was awarded the Victoria Cross for his bravery during this incident and was able to rescue an officer and a scout that had been wounded in the advance.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(110).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A soldier looks pensively off in to the distance as the bodies of enemies and comrades surround him. Despite the bravado depicted in many propaganda images life in the trenches had a very profound affect on the psyche of many soldiers who served there.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(111).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("In this illustration a British soldier is depicted taking control of a German trench single-handedly, as the wounded and terrified enemy surrender. Propaganda images such as this were commonly used in newspapers and reports giving the civilians back home a seemlier view of the fighting.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(112).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("The boggy conditions on the western front were not just a hazard to soldiers, but also to the beasts that were necessary to the war effort.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(113).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Barbed wire entanglements could only be erected at night as soldiers would be struck down by machine-guns if they were spotted by the enemy.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(114).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("During a night-time bombing attack on the German lines Private Mauffinades' party is struck by a bomb. Undeterred he carries his wounded captain on his shoulders, and crawls to the British lines. under heavy fire, saving the man's life.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(115).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("An illustration showing the Royal Welsh Fusiliers participating in furious hand to hand fighting in the crater at Givenchy, where the German forces had sprang an enormous mine under the British trenches. Such tactics were commonly used by troops of all nations during the war.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(116).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Religion was important in keeping up the morale of the troops. Here we see an image of a soldier conducting an impromptu service during a Sunday on the western front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(117).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British soldiers ‘cleaning up’ after an advance on the western front, collecting the kits of dead comrades and any equipment that the enemy had left behind.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(118).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British soldiers call to move forward as their parties attack on the western front.The soldiers charge with their bayonets ready to strike.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(119).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("An artist's impression of the inside of a captured German dugout, the floor lies strewn with equipment and medical supplies.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(120).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Soldiers fuse shells despite the bitter cold.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(121).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Pack mules deliver supplies by darkness.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(122).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Soldiers skirmish in the snow as they leap between hidden trenches and clamber up frozen hills.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(123).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("This oil painting by Stanley Llewellyn Wood, depicts Captain Reginald James Young, 2"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("nd")]), _vm._v(" Battalion, the Duke of Cambridge’s Own (Middlesex Regiment), in action. For his courageousness in this deed he would be awarded the Military Cross.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(124).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("4 November 1916 – Before the outbreak of fighting for the northern half of Zenith Trench, east of Lesboeufs, a young British soldier was reported to have crept in to a German trench whilst reconnoitring a position and stolen their entire machine-gun whilst the soldiers slept.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(125).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British soldiers clear out snow filled German trenches.The bitter cold of the winter hit the troops in the trenches the hardest where freezing conditions claimed the lives of many men.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(126).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A soldier surveys the carnage below as smoke rises from a bombed out dugout.The German defences were solidly build and often able to withstand considerable barrages.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(127).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British soldiers advance through smoke.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(128).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("An altercation between foes at night.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(129).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Tolling the gas alarm on a sanctuary bell.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(130).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A soldier calls back to members of his party.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(131).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Depicted here are men of a Highland regiment, clad in white, with white smocks reaching below their kilts, and their steel helmets painted white, as they make a night raid over snow on German trenches on the western front.Their bayonets are fixed to avoid making any noise.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(132).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("This panorama shows the carnage and confusion that was ever a feature on the battlefields of the Great War. Infantry weaves its way through explosions and trenches.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(133).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("An officer commands his troops as they face off against the enemy in a ruined building; many villages on the western front were entirely destroyed.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(134).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Here we see a dramatic artist’s impression of British infantry mounting a large scale charge.They rush through abandoned enemy field artillery toward the woods in the distance.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(135).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("31 March 1917 – Allied forces rush the last barricade of the retreating German rearguard at Heudicourt, attacking with bayonets and even fists.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(136).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Allied soldiers are shown here in the act of throwing bombs in an attempt to clear a path through enemy trenches.This was understandably a dangerous business.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(137).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("10 April 1917 – British machine-gun defences are shown at Tilloy. A line of weapons such as this would inflict deadly impact upon any advancing enemy.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(138).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Huge craters and decimated trees are seen here.The war changed the landscape of huge swathes of land entirely, ravaging the countryside of the western front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(139).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A hasty defence is arranged as a working party spy oncoming enemy soldiers appearing from the right of the image in this illustration. Constant vigilance was required in the field.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(140).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("12 April 1917 – Tanks played a great part in the capture of the villages of Wancourt and Heninel on the Cojeul River, where two of these land cruisers undertook a forty-hour-long battle.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(141).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Many thousands of yards of wire were flattened out by tanks to the south-east of Arras. Dugouts were broken in, and machine-gun corners were destroyed by them in the fighting along this front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(142).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("16 April 1917 – French tanks invade German trenches on the Aisne. To soldiers unused to such machinery the tanks were a truly fearsome sight.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(143).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Tanks cleared the way for the British infantry into the twin villages of Heninel and Wancourt, having a particularly devastating effect in Heninel.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(144).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British soldiers on the ground observe two of their comrades escaping fire via parachutes after they had been fired upon by a swooping German Albatross.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(145).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A skirmish breaks out as a British working party nears the new German line.To the left of the picture we see a soldier still wielding his pick.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(146).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("The German troops had a far more sophisticated system of building trenches and shelters which often made them seem like underground fortresses to the hard pressed British.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(147).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Horses transport wounded by sledge.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(148).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Machine-gunners take cover.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(149).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("This sketch by F. Matania shows a village under heavy shell-fire.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(150).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("14 June 1917 – Wounded at Messines receive much needed first aid and shelter.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(151).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Australian forces crossing the Douvre under heavy machine-gun fire at Messines.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(152).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A British working party is met by a salvo of German gas-shells accurately ranged across their path. When dropped in a line gas shells proved a very effective barrier.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(153).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("This spirited image shows British soldiers rushing a German battery in the open. They were able to capture six field-guns on this occasion, a remarkable feat.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(154).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Highlanders storming a ruined brick factory, heavily armed with machine guns, which was holding up an advance near Ypres.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(155).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("To the left of this image a British soldier is seen bombing a German trench whilst illuminated by flares during a night raid that successfully captured three German prisoners.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(156).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("At Messines, soldiers from the Cheshires encounter machine-gun fire and struggle through unbroken barbed-wire defences.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(157).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("17 May 1917 – Stretcher-bearers bringing in wounded, while a despatch-rider goes off with the latest information at an aid-post near the Bullecourt battlefield.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(158).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("New Zealand troops practice a smoke attack using portable smoke generators.The smoke would be used to mask their advance, hindering enemy fire.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(159).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("In this illustration by D. MacPherson, Scottish troops are shown going ‘over the top’ to take part in a night raid on the western front as a heavy barrage falls ahead of them.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(160).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British soldiers attempt to repell an attack by armour clad German troops wielding flame-throwers who have attacked through a smoke screen.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(161).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Italian troops sporting gas smasks attempt to disperse Austrian asphyxiating gas by using chemical fumes diffused from braziers on the Isonzo front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(162).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("September 1917 – An officer of the Somerset Light Infantry, with six men, capturing forty-two prisoners and eight machine-guns in the large block house shown.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(163).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("When swampy conditions rendered terrain impossible for vehicles to traverse soldiers were called up to transport the shells to guns by hand on the western front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(164).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("31 July-November 1917 – This image shows a bombing-party drawing supplies from a bomb-store in the support trenches to carry up to the firing line during the Third Battle of Ypres.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(165).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A runner delivers his given message despite being gravely wounded en route. During the war messengers often became easy targets for enemy snipers making it a dangerous task.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(166).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("'The only living souls to be seen on the vast expanse of the battlefield', British stretcher bearers undertake the grisly task of bringing in a wounded soldier under shell fire.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(167).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("An artist’s impression of soldiers at a water pipe on the western front.The carefully sterilised water was stored in tanks at fixed stations which supplied the men with vital clean drinking water.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(168).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A surprise attack is sprung upon some motor-omnibuses taking relief up to the trenches. Disruption of supplies and reinforcement made life in the trenches very difficult indeed.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(169).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British artillery are shown making the slow advance through the boggy mud that characterised the terrain of Flanders battlefields, with which even the strongest horses struggled.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(170).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("During the Third Battle of Ypres, British troops bomb an enemy concrete 'pill-box' through the firing slit near Hollebeke and La Basse Ville.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(171).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("This illustration shows a British soldier sneakily nearing a German machine-gunner who has been posted on a railway embankment during fighting along the Comines Canal.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(172).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("On the road to Passchendaele a working party lays duckboard tracks and drains the floods to secure the route advancing infantry shall take.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(173).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Conquering troops examine the contents of a captured German position on the battlefield in Flanders on the western front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(174).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Outmanoeuvred German soldiers are cleared from their formidable machine-gun position by allied troops. Debris from the attack litters the battlefield around them.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(175).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("German soldiers burst through the British line in a counter-attack east of Ypres.Their enemy attempts to hold them off using two Lewis guns until reinforcements arrives.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(176).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Outside Ypres, British and Indian troops are pictured on the enemy’s trenches battling through driving rain and mist as the Flemish city burns in the background.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(177).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Lead by their pipers, a Scottish battalion marches back from the trenches.These pipers also served as stretcher-bearers until they were augmented into large pipe bands later in the war.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(178).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("In a piece entitled 'They That Walk In Darkness', a blinded officer of the Highlanders is lead from the battlefield by two of his countrymen. Gas attacks and shrapnel accounted for the loss of many soldiers' eyesight on the battlefield.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(179).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Men of the New Zealand Artillery operate their weapon from a strongly-constructed dugout on the western front, as the soldier in the foreground prepares shells for firing.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(180).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Dead German soldiers lay strewn across the battlefield in the muddy tracts of France and Flanders, where they have fallen victim to enemy night-raids.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(181).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("4 October 1917 – A British pilot swoops low over German lines during reconnaissance. Enemy soldiers can be seen below attacking the aircraft with rifles and heavy guns.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(182).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("4 October 1917 – A tank comes to the aid of exhausted Midland troops at Terrier Farm in Ypres. After the arrival of the tank the enemy garrison of the fort surrendered.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(183).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("In this image horse-drawn scrapers level the ground to provide a flat surface for the stacks of shells that would be stored in fresh ammunition dump sites.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(184).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Regimental stretcher-bearers make their way through the water-logged marshland of Ypres.This job often involved crawling on all fours through the bog.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(185).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("6 November 1917 – Canadian forces clearing a German held position to the left of a village, at the cross-roads near Mosselmarkt.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(186).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Pioneers and labour battalions bridging trenches, filling in shell-craters, and clearing away debris.These essential tasks were often conducted under heavy fire.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(187).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("New Zealand field-gunners participate in an artillery battle on the western front despite the freezing snow around them, which made advancement difficult.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(188).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("An example of the camouflage winter clothing used by allied soldiers during the winter of 1917.These suits were craftily designed for use in snowy conditions.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(189).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British soldiers step in to act as a brake for the horses during an snowy spell in France. Unused to such conditions, horses often found the icy roads hard going.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(190).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British soldiers in France fire a rocket to direct their artillery. This important task could have lethal consequences if performed incorrectly.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(191).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("A messenger arrives at his destination ready to relay information and orders to waiting troops.These men had to be brave and highly fit as on the battlefield every second counts, and a message delivered too late could spell disaster.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(192).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Two soldiers and an officer of the Royal Engineers laying an essential telephone cable along a trench near the fighting-line on the Cambrai Front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(193).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("March 1918 – German soldiers advance during their spring offensive.The gas-masked British gunners shown here can be seen firing point-blank in to clouds of deadly smoke.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(194).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("German soldiers tragically caught in clouds of their nation’s poison gas struggle forward.The horror of the gas attacks during the Great War ensured it would be banned from future use.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(195).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British soldiers make a night attack on enemy trenches. German rockets can be seen in the sky, these were used to illuminate the oncoming soldiers and signal a need for support.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(196).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("French infantry advance on the western front. Each soldier was equipped with an entrenching tool as part of his field equipment which he would use to dig a partial shelter for himself.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(197).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("March 1918 – British soldiers leave their shell-hole shelters to support some ‘whippet’ tanks, these machines were to prove crucial in deciding the outcome of the Battle for Amiens.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(198).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("May 1918 – American infantry, with French tanks in support, are seen leaving their trenches to attack Cantigny, which they would successfully capture along with two hundred prisoners. The American forces advanced nearly a mile in just forty minutes.This was one of the first major American successes of the war.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(199).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Near Rheims men of the West Yorkshire Regiment return from action. They had been able to successfully repulse a German attack upon their Regiment earlier that day.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(201).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("British troops advance through a wooded area carrying rifles and bayonets. Fallen trees and soldiers on the ground made for a tricky advance.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img(202).jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("Summer 1918 – A bold American soldier advances forward in a bayonet charge. Depicted close to the end of the war, men such as this had been exceptionally lucky to survive such a tragic event that still remains one of the deadliest conflicts in human history.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-118bebef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/teil1.vue
// module id = 69
// module chunks = 0